import { useMemo } from 'react';
import { useApi, apiResolver } from '@/api/useApi';

export function useManageTenantStripeApi(tenantId: string) {
  const { api } = useApi();

  return useMemo(
    () => ({
      createPaymentCheckout: async (successUrl: string, cancelUrl: string) =>
        apiResolver<string>(
          api.post(`/gateway/tenant/${tenantId}/payment-checkout`, { successUrl, cancelUrl }),
        ),
    }),
    [api, tenantId],
  );
}
